module.exports = __webpack_public_path__ + "img/chalkboard-teacher.18fdb74e.jpg";